import { t } from "../i18n/i18n";
export class ModuleLoadError extends Error {
    constructor(slug, cause) {
        super(`ModuleLoadError: ${t("shell.module.load_error", { slug })}${cause ? `: ${cause}` : ""}`);
        this.name = "ModuleLoadError";
    }
}
// У продукта нет экрана вовсе (паспорт без front — kind:system без menu_items, media и
// подобные): entry.js отвечает 404, а не временным сбоем, повторный импорт того же слага
// ничего не изменит — отдельный тип ошибки, чтобы ModuleHost не показывал это как крах экрана.
export class NoScreenError extends Error {
    constructor(slug) {
        super(`NoScreenError: ${slug}`);
        this.name = "NoScreenError";
    }
}
// Кеш загруженных продуктов по слагу — повторная навигация не ходит в сеть.
const _cache = new Map();
// Слаги, у которых entry.js уже ответил 404 в этой вкладке — решение не переспрашивается на
// каждый ремоунт ModuleHost (T-SHELL-OPENPRODUCT-STORM), сброс только явным evictModule.
const _noScreenCache = new Set();
export async function loadModule(slug) {
    const cached = _cache.get(slug);
    if (cached)
        return cached;
    if (_noScreenCache.has(slug))
        throw new NoScreenError(slug);
    const url = `/m/${slug}/entry.js`;
    let probe;
    try {
        // HEAD одним запросом отличает «у продукта вовсе нет сборки фронта» (404) от прочих сбоев
        // загрузки ДО дорогого import() — без этого проверка результата import() по тексту ошибки
        // браузера была бы хрупкой (формат сообщения разный у Chrome/Firefox/Safari).
        probe = await fetch(url, { method: "HEAD" });
    }
    catch (e) {
        throw new ModuleLoadError(slug, e);
    }
    if (probe.status === 404) {
        _noScreenCache.add(slug);
        throw new NoScreenError(slug);
    }
    let mod;
    try {
        // webpackIgnore — это динамический импорт удалённого ESM-бандла продукта,
        // а не локальный чанк, webpack не должен пытаться его собрать.
        mod = await import(/* webpackIgnore: true */ `/m/${slug}/entry.js`);
    }
    catch (e) {
        throw new ModuleLoadError(slug, e);
    }
    if (!mod || typeof mod.mount !== "function" || typeof mod.unmount !== "function") {
        throw new ModuleLoadError(slug, t("shell.module.invalid_entry"));
    }
    const entry = mod;
    _cache.set(slug, entry);
    return entry;
}
export function evictModule(slug) {
    _cache.delete(slug);
    _noScreenCache.delete(slug);
}
